/* eslint-disable sort/object-properties */
// eslint-disable-next-line @typescript-eslint/consistent-type-imports
import { EUROPACE_IMPORT_PROCESS_ERRORS } from './europace';
import type { ValueOf } from './util/typeUtils';

export const LOAN_REQUEST_USAGES = {
    ENERGETISCHE_SANIERUNG: 'ENERGETISCHE_SANIERUNG',
    FAHRZEUGKAUF: 'FAHRZEUGKAUF',
    FREIE_VERWENDUNG: 'FREIE_VERWENDUNG',
    MODERNISIEREN: 'MODERNISIEREN',
    UMSCHULDUNG: 'UMSCHULDUNG',
} as const;

export type LOAN_REQUEST_USAGE = ValueOf<typeof LOAN_REQUEST_USAGES>;

export const LOAN_REQUEST_CAR_TYPES = {
    CAR: 'CAR',
    MOTORCYCLE: 'MOTORCYCLE',
    CAMPER_OR_CARAVAN: 'CAMPER_OR_CARAVAN',
} as const;

export type LOAN_REQUEST_CAR_TYPE = ValueOf<typeof LOAN_REQUEST_CAR_TYPES>;

export const LOAN_REQUEST_CAR_VENDORS = {
    NONE: 'NONE',
    DEALER: 'DEALER',
    PRIVATE: 'PRIVATE',
} as const;

export type LOAN_REQUEST_CAR_VENDOR = ValueOf<typeof LOAN_REQUEST_CAR_VENDORS>;

export const LOAN_REQUEST_CAR_FINANCING_WISHES = {
    BALLOON_FINANCING: 'BALLOON_FINANCING',
    CLASSIC_FINANCING: 'CLASSIC_FINANCING',
} as const;

export type LOAN_REQUEST_CAR_FINANCING_WISH = ValueOf<typeof LOAN_REQUEST_CAR_FINANCING_WISHES>;

export const LOAN_REQUEST_CLASSIFICATION = {
    automatic: 'automatic',
    classification: 'classification',
    duplicate: 'duplicate',
    manual: 'manual',
    moved: 'moved',
} as const;

/** Kinds of notifications a user can have processed (handled) in the notification bell. */
export const PROCESSED_NOTIFICATION_KINDS = {
    ACTIVE_USER_SET: 'ACTIVE_USER_SET',
    ASSIGNED_USER_ADDED: 'ASSIGNED_USER_ADDED',
    BANK_REPORT: 'BANK_REPORT',
    DOCUMENT: 'DOCUMENT',
    RESUBMISSION: 'RESUBMISSION',
} as const;

export type ProcessedNotificationKind = ValueOf<typeof PROCESSED_NOTIFICATION_KINDS>;

export const LOAN_REQUEST_OFFER_BANKS = {
    Auxmoney: 'Auxmoney',
    'Bank of Scotland': 'Bank of Scotland',
    BarclayCard: 'BarclayCard',
    Commerzbank: 'Commerzbank',
    'Consors Finanz': 'Consors Finanz',
    'Consors-Nachrang': 'Consors-Nachrang',
    CreditPlus: 'CreditPlus',
    DKB: 'DKB',
    DSL: 'DSL',
    INGDiba: 'INGDiba',
    PSD: 'PSD',
    Qlick: 'Qlick',
    'Santander Consumer': 'Santander Consumer',
    'Santander Car': 'Santander Car',
    Sberbank: 'Sberbank',
    Sigma: 'Sigma',
    SKG: 'SKG',
    Sparkasse: 'Sparkasse',
    SWK: 'SWK',
    Targobank: 'Targobank',
    Volksbank: 'Volksbank',
    Bank11: 'Bank11',
} as const;

// List provided in https://synatix.atlassian.net/browse/KC-4252
export const LOAN_REQUEST_EUROPACE_BANKS = {
    Auxmoney: 'Auxmoney',
    'Bausparkasse Wuestenrot': 'Bausparkasse Wuestenrot',
    'Consors Finanz': 'Consors Finanz',
    'Deutsche Bank': 'Deutsche Bank',
    DKB: 'DKB',
    DSL: 'DSL', // angepasst
    INGDiba: 'INGDiba', // angepasst
    Norisbank: 'Norisbank',
    OLB: 'OLB',
    'PSD Muenchen': 'PSD Muenchen',
    'PSD Hannover': 'PSD Hannover',
    'PSD Karlsruhe-Neustadt': 'PSD Karlsruhe-Neustadt',
    'PSD RheinNeckarSaar': 'PSD RheinNeckarSaar',
    Qlick: 'Qlick',
    'Santander Consumer': 'Santander Consumer',
    Skatbank: 'Skatbank',
    SKG: 'SKG',
    SWK: 'SWK', // angepasst
    Targobank: 'Targobank',
    'VVRB eG Reinheim': 'VVRB eG Reinheim',
    'KSK Doebeln': 'KSK Doebeln',
    'Alte Leipziger Bauspar': 'Alte Leipziger Bauspar',
    'PSD Kiel': 'PSD Kiel',
    'Signal Iduna': 'Signal Iduna',
    'Hanseatic Bank': 'Hanseatic Bank',
    'PSD Rhein-Ruhr': 'PSD Rhein-Ruhr',
    'Sparkasse Fuerth': 'Sparkasse Fuerth',
    'Sparkasse Mansfeld-Suedharz': 'Sparkasse Mansfeld-Suedharz',
    'VR-Bank Altenburger Land': 'VR-Bank Altenburger Land',
} as const;

export const LOAN_REQUEST_ALL_BANKS = {
    ...LOAN_REQUEST_OFFER_BANKS,
    ...LOAN_REQUEST_EUROPACE_BANKS,
} as const;

export type LOAN_REQUEST_OFFER_BANK = ValueOf<typeof LOAN_REQUEST_OFFER_BANKS>;

export const LOAN_REQUEST_OFFER_PRESALES_TRANSITION = {
    TODO: 'TODO',
} as const;

export const LOAN_REQUEST_BANK_REMOVAL_REASONS = {
    APPLICANT_2_REMOVED_BY_DSGVO: 'APPLICANT_2_REMOVED_BY_DSGVO',
} as const;
export type LOAN_REQUEST_BANK_REMOVAL_REASON = ValueOf<typeof LOAN_REQUEST_BANK_REMOVAL_REASONS>;

export const LOAN_REQUEST_OFFER_RESIDUAL_DEBT_INSURANCE = {
    DEATH: 'DEATH',
    'DEATH_WORK-INCAPACITY': 'DEATH_WORK-INCAPACITY',
    'DEATH_WORK-INCAPACITY_UNEMPLOYMENT': 'DEATH_WORK-INCAPACITY_UNEMPLOYMENT',
    NONE: 'NONE',
} as const;

export const RESIDUAL_DEBT_INSURANCES = {
    DEATH: 'DEATH',
    UNEMPLOYMENT: 'UNEMPLOYMENT',
    WORK_INCAPACITY: 'WORK_INCAPACITY',
} as const;

export type RESIDUAL_DEBT_INSURANCE = keyof typeof RESIDUAL_DEBT_INSURANCES;

export const LOAN_REQUEST_OFFER_STATUS = {
    OFFER_COULD_NOT_BE_CREATED: 'OFFER_COULD_NOT_BE_CREATED',
    APPROVED: 'APPROVED',
    AT_BANK: 'AT_BANK',
    AT_BANK_INCOMPLETE: 'AT_BANK_INCOMPLETE',
    COMMISSION_RECEIVED: 'COMMISSION_RECEIVED',
    OFFER_CREATED: 'OFFER_CREATED',
    OFFER_EXPIRED: 'OFFER_EXPIRED',
    OFFER_PENDING: 'OFFER_PENDING',
    REJECTED: 'REJECTED',
    REVOCATION: 'REVOCATION',
    PAID_OUT: 'PAID_OUT',
    CANCELLED: 'CANCELLED',
} as const;

export const OFFER_HISTORY_STATUSES = {
    ...LOAN_REQUEST_OFFER_STATUS,
    NOT_REQUESTABLE: 'NOT_REQUESTABLE',
    NOT_REQUESTED: 'NOT_REQUESTED',
} as const;
export type OFFER_HISTORY_STATUS = ValueOf<typeof OFFER_HISTORY_STATUSES>;

export const LOAN_REQUEST_OFFER_COMMISSION_STATUSES = {
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    RECEIVED: 'RECEIVED',
} as const;

export type LOAN_REQUEST_OFFER_COMMISSION_STATUS = keyof typeof LOAN_REQUEST_OFFER_COMMISSION_STATUSES;

export type LOAN_REQUEST_OFFER_STATUS_TYPES = keyof typeof LOAN_REQUEST_OFFER_STATUS;

export const LOAN_REQUEST_OFFER_SOURCES = {
    CONSORS: 'CONSORS',
    EUROPACE: 'EUROPACE',
    MANUAL: 'MANUAL',
    EUROPACE_SYNC: 'EUROPACE_SYNC',
} as const;

export type LOAN_REQUEST_OFFER_SOURCE = keyof typeof LOAN_REQUEST_OFFER_SOURCES;
export type LOAN_REQUEST_OFFER_SOURCE_WITHOUT_MANUAL = Exclude<LOAN_REQUEST_OFFER_SOURCE, 'MANUAL'>;

export type LOAN_REQUEST_OFFER_FILTERS = {
    criteria: {
        favored?: boolean;
    };
    status: Array<LOAN_REQUEST_OFFER_STATUS_TYPES>;
};

export const REAL_ESTATE_TYPES = {
    BUEROGEBAEUDE: 'BUEROGEBAEUDE',
    EIGENTUMSWOHNUNG: 'EIGENTUMSWOHNUNG',
    EINFAMILIENHAUS: 'EINFAMILIENHAUS',
    MEHRFAMILIENHAUS: 'MEHRFAMILIENHAUS',
} as const;

export const REAL_ESTATE_USAGES = {
    EIGENGENUTZT: 'EIGENGENUTZT',
    EIGENGENUTZT_UND_VERMIETET: 'EIGENGENUTZT_UND_VERMIETET',
    VERMIETET: 'VERMIETET',
} as const;

export const CHILD_BENEFIT_TYPES = {
    AB_VIERTEM_KIND: 'AB_VIERTEM_KIND',
    DRITTES_KIND: 'DRITTES_KIND',
    ERSTES_ODER_ZWEITES_KIND: 'ERSTES_ODER_ZWEITES_KIND',
} as const;

export const INFORMATION_SOURCE = {
    FORMULAR: 'FORMULAR',
    MANUALLY: 'MANUALLY',
    SCHUFA: 'SCHUFA',
} as const;
// eslint-disable-next-line @typescript-eslint/no-redeclare
export type INFORMATION_SOURCE = keyof typeof INFORMATION_SOURCE;

export const CHANGE_ACK_TYPES = {
    documents: 'documents',
} as const;

export const LOANREQUEST_BUCKETS = {
    BAUFI: 'BAUFI',
    IK: 'IK',
    IK_CLEARING: 'IK_CLEARING',
    INCOMPLETE: 'INCOMPLETE',
    JOB_STATUS: 'JOB_STATUS',
    NOT_FINANCEABLE: 'NOT_FINANCEABLE',
    PARTNER_SERVICE: 'PARTNER_SERVICE',
    POTENTIAL_LEAD: 'POTENTIAL_LEAD',
    PK: 'PK',
    SCHUFA_ERROR: 'SCHUFA_ERROR',
    SCHUFA_NEGATIVE: 'SCHUFA_NEGATIVE',
    SCHUFA_SCORE: 'SCHUFA_SCORE',
    SELF_EMPLOYED: 'SELF_EMPLOYED',
    PROCHECK: 'PROCHECK',
} as const;

export type LOANREQUEST_BUCKET = (typeof LOANREQUEST_BUCKETS)[keyof typeof LOANREQUEST_BUCKETS];

export const LOANREQUEST_BUCKETS_FILTERS = {
    NONE: 'NONE',
} as const;
export type LOANREQUEST_BUCKETS_FILTER = ValueOf<typeof LOANREQUEST_BUCKETS_FILTERS>;

export const LOANREQUEST_STATUS_LIMITS = {
    INITIAL: 1,
} as const;

export type LOANREQUEST_STATUS_LIMIT = ValueOf<typeof LOANREQUEST_STATUS_LIMITS>;

export const LOANREQUEST_STATUSES = {
    APPROVED: 'APPROVED',
    CANCELED: 'CANCELED',
    IN_PROGRESS: 'IN_PROGRESS',
    INITIAL: 'INITIAL',
    OFFER_AT_BANK: 'OFFER_AT_BANK',
    OFFER_AT_CUSTOMER: 'OFFER_AT_CUSTOMER',
} as const;

export type LOANREQUEST_STATUS = ValueOf<typeof LOANREQUEST_STATUSES>;

export const SUB_STATUS_INITIAL = {
    FIRST_ATTEMPT: 'FIRST_ATTEMPT',
    FOLLOW_UP_DAY_2: 'FOLLOW_UP_DAY_2',
    INCOMPLETE: 'INCOMPLETE',
} as const;

export type SUB_STATUS_INITIAL_TYPE = ValueOf<typeof SUB_STATUS_INITIAL>;

export const SUB_STATUS_IN_PROGRESS = {
    FIRST_ATTEMPT: 'FIRST_ATTEMPT',
    FOLLOW_UP_DAY_2: 'FOLLOW_UP_DAY_2',
    FOLLOW_UP_DAY_3: 'FOLLOW_UP_DAY_3',
    FAILED_ATTEMPT: 'FAILED_ATTEMPT',
    FAILED_ATTEMPT_2: 'FAILED_ATTEMPT_2',
    RESUBMISSION: 'RESUBMISSION',
} as const;

export type SUB_STATUS_IN_PROGRESS_TYPE = ValueOf<typeof SUB_STATUS_IN_PROGRESS>;

export const SUB_STATUS_OFFER_AT_CUSTOMER = {
    FOLLOW_UP_DAY_1: 'FOLLOW_UP_DAY_1',
    FOLLOW_UP_DAY_2: 'FOLLOW_UP_DAY_2',
    FOLLOW_UP_DAY_3: 'FOLLOW_UP_DAY_3',
    OFFER: 'OFFER',
} as const;

export type SUB_STATUS_OFFER_AT_CUSTOMER_TYPE = ValueOf<typeof SUB_STATUS_OFFER_AT_CUSTOMER>;

export const SUB_STATUS_OFFER_AT_BANK = {
    MISSING_DOCUMENTS: 'MISSING_DOCUMENTS',
    OFFER_RECEIVED: 'OFFER_RECEIVED',
    REJECTED_ALTERNATIVE_OFFER: 'REJECTED_ALTERNATIVE_OFFER',
} as const;

export type SUB_STATUS_OFFER_AT_BANK_TYPE = ValueOf<typeof SUB_STATUS_OFFER_AT_BANK>;

export const SUB_STATUS_APPROVED = {
    COMMISSION_PAID: 'COMMISSION_PAID',
    PAYOUT_BANK: 'PAYOUT_BANK',
} as const;

export type SUB_STATUS_APPROVED_TYPE = ValueOf<typeof SUB_STATUS_APPROVED>;

export const LOANREQUEST_DEFAULT_STATUS = {
    ACTIVE: 'ACTIVE',
    ALL: 'ALL',
} as const;

// eslint-disable-next-line @typescript-eslint/no-redeclare
export type LOANREQUEST_DEFAULT_STATUS = keyof typeof LOANREQUEST_DEFAULT_STATUS;

export const LOANREQUEST_STATUS_REASONS = {
    APPRENTICE: 'APPRENTICE',
    BASED_ENTIRELY_ABROAD: 'BASED_ENTIRELY_ABROAD',
    BUDGET_ACCOUNT: 'BUDGET_ACCOUNT',
    COMPETITIVE_OFFER_ACCEPTED: 'COMPETITIVE_OFFER_ACCEPTED',
    DEBT_COLLECTION: 'DEBT_COLLECTION',
    DEBT_EQUITY_RATIO: 'DEBT_EQUITY_RATIO',
    DEBT_VELOCITY: 'DEBT_VELOCITY',
    FAKE: 'FAKE',
    FINANCING_REQUEST_EXPIRED: 'FINANCING_REQUEST_EXPIRED',
    GAMBLING: 'GAMBLING',
    GARNISHMENT: 'GARNISHMENT',
    HOUSEWIFE: 'HOUSEWIFE',
    INITIAL_TIMEOUT: 'INITIAL_TIMEOUT',
    MULTIPLE_REQUEST: 'MULTIPLE_REQUEST',
    NATIONALITY: 'NATIONALITY',
    NEGATIVE_CREDIT_RATING: 'NEGATIVE_CREDIT_RATING',
    NO_ELIGIBLE_INCOME: 'NO_ELIGIBLE_INCOME',
    NOT_REACHED: 'NOT_REACHED',
    OFFERS_NOT_ACCEPTED: 'OFFERS_NOT_ACCEPTED',
    RETURN_DEBIT_NOTES: 'RETURN_DEBIT_NOTES',
    SCAM: 'SCAM',
    SCORING: 'SCORING',
    SELF_EMPLOYED: 'SELF_EMPLOYED',
    STUDENT: 'STUDENT',
    TEST: 'TEST',
    UNEMPLOYED: 'UNEMPLOYED',
    WISHES_DATA_DELETION: 'WISHES_DATA_DELETION',
} as const;
export type LOANREQUEST_STATUS_REASON = keyof typeof LOANREQUEST_STATUS_REASONS;

export const CUSTOMER_CANCEL_REASONS = [
    'NOT_REACHED',
    'OFFERS_NOT_ACCEPTED',
    'COMPETITIVE_OFFER_ACCEPTED',
    'FINANCING_REQUEST_EXPIRED',
] as const;
export type CUSTOMER_CANCEL_REASON = (typeof CUSTOMER_CANCEL_REASONS)[number];

export const MEDIATOR_PERSONAL_CANCEL_REASONS = [
    'NEGATIVE_CREDIT_RATING',
    'NATIONALITY',
    'BASED_ENTIRELY_ABROAD',
    'SCORING',
] as const;
export type MEDIATOR_PERSONAL_CANCEL_REASON = (typeof MEDIATOR_PERSONAL_CANCEL_REASONS)[number];

export const MEDIATOR_PROFESSIONAL_CANCEL_REASONS = [
    'UNEMPLOYED',
    'SELF_EMPLOYED',
    'APPRENTICE',
    'STUDENT',
    'HOUSEWIFE',
] as const;
export type MEDIATOR_PROFESSIONAL_CANCEL_REASON = (typeof MEDIATOR_PROFESSIONAL_CANCEL_REASONS)[number];

export const MEDIATOR_FINANCIAL_CANCEL_REASONS = [
    'NO_ELIGIBLE_INCOME',
    'BUDGET_ACCOUNT',
    'DEBT_EQUITY_RATIO',
    'DEBT_VELOCITY',
] as const;
export type MEDIATOR_FINANCIAL_CANCEL_REASON = (typeof MEDIATOR_FINANCIAL_CANCEL_REASONS)[number];

export const MEDIATOR_DOCUMENT_REVIEW_CANCEL_REASONS = [
    'DEBT_COLLECTION',
    'RETURN_DEBIT_NOTES',
    'GAMBLING',
    'GARNISHMENT',
] as const;
export type MEDIATOR_DOCUMENT_REVIEW_CANCEL_REASON = (typeof MEDIATOR_DOCUMENT_REVIEW_CANCEL_REASONS)[number];

export const DATA_CORRECTION_CANCEL_REASONS = ['MULTIPLE_REQUEST', 'SCAM', 'FAKE', 'INITIAL_TIMEOUT', 'TEST'] as const;
export type DATA_CORRECTION_CANCEL_REASON = (typeof DATA_CORRECTION_CANCEL_REASONS)[number];

export const DATA_DELETION_CANCEL_REASONS = ['WISHES_DATA_DELETION'] as const;
export type DATA_DELETION_CANCEL_REASON = (typeof DATA_DELETION_CANCEL_REASONS)[number];

export type CANCEL_REASON =
    | CUSTOMER_CANCEL_REASON
    | MEDIATOR_PERSONAL_CANCEL_REASON
    | MEDIATOR_PROFESSIONAL_CANCEL_REASON
    | MEDIATOR_FINANCIAL_CANCEL_REASON
    | MEDIATOR_DOCUMENT_REVIEW_CANCEL_REASON
    | DATA_CORRECTION_CANCEL_REASON
    | DATA_DELETION_CANCEL_REASON;

export const REASON_CATEGORIES = {
    CUSTOMER_REASONS: 'CUSTOMER_REASONS',
    DATA_CORRECTION: 'DATA_CORRECTION',
    DATA_DELETION: 'DATA_DELETION',
    MEDIATOR_REASONS_MULTIPLE: 'MEDIATOR_REASONS_MULTIPLE',
    MEDIATOR_REASONS_SINGLE: 'MEDIATOR_REASONS_SINGLE',
} as const;
export type REASON_CATEGORY = keyof typeof REASON_CATEGORIES;

export const CANCEL_REASON_TABS = {
    CUSTOMER: 'CUSTOMER',
    MEDIATOR: 'MEDIATOR',
    DATA: 'DATA',
} as const;

export type CANCEL_REASON_TAB = ValueOf<typeof CANCEL_REASON_TABS>;

export const CANCEL_REASON_TAB_BY_CATEGORY: Record<REASON_CATEGORY, CANCEL_REASON_TAB> = {
    CUSTOMER_REASONS: CANCEL_REASON_TABS.CUSTOMER,
    DATA_CORRECTION: CANCEL_REASON_TABS.DATA,
    DATA_DELETION: CANCEL_REASON_TABS.DATA,
    MEDIATOR_REASONS_MULTIPLE: CANCEL_REASON_TABS.MEDIATOR,
    MEDIATOR_REASONS_SINGLE: CANCEL_REASON_TABS.MEDIATOR,
};

export const SUB_STATUSES = {
    ...SUB_STATUS_INITIAL,
    ...SUB_STATUS_IN_PROGRESS,
    ...SUB_STATUS_OFFER_AT_CUSTOMER,
    ...SUB_STATUS_OFFER_AT_BANK,
    ...SUB_STATUS_APPROVED,
    ...REASON_CATEGORIES,
} as const;

export type SUB_STATUSES_TYPE = ValueOf<typeof SUB_STATUSES>;

export const SUB_STATUSES_FILTERS = {
    NONE: 'NONE',
} as const;
export type SUB_STATUSES_FILTERS_TYPE = ValueOf<typeof SUB_STATUSES_FILTERS>;

export const LOAN_REQUEST_ADVISER_FILTERS = {
    NONE: 'NONE',
} as const;
export type LOAN_REQUEST_ADVISER_FILTERS_TYPE = ValueOf<typeof LOAN_REQUEST_ADVISER_FILTERS>;

export const LOAN_REQUEST_OFFER_STATES = {
    FAILED: 'FAILED',
    PENDING: 'PENDING',
    SUCCESS: 'SUCCESS',
} as const;
export type LOAN_REQUEST_OFFER_STATE = keyof typeof LOAN_REQUEST_OFFER_STATES;

export const OFFER_REQUEST_ERRORS = {
    EUROPACE: {
        ACCEPT_OFFER: {
            FORBIDDEN_ERROR: 'EUROPACE_ACCEPT_OFFER_FORBIDDEN_ERROR',
            UNAUTHORIZED_ERROR: 'EUROPACE_ACCEPT_OFFER_UNAUTHORIZED_ERROR',
            UNEXPECTED_ERROR: 'EUROPACE_ACCEPT_OFFER_UNEXPECTED_ERROR',
            UNSUPPORTED_MEDIA_TYPE_ERROR: 'EUROPACE_ACCEPT_OFFER_UNSUPPORTED_MEDIA_TYPE_ERROR',
        } as const,
        GRAPHQL: {
            AUTHENTICATION_ERROR: 'EUROPACE_AUTHENTICATION_ERROR',
            BAD_REQUEST_ERROR: 'EUROPACE_GRAPHQL_BAD_REQUEST_ERROR',
            CONFLICT_ERROR: 'EUROPACE_GRAPHQL_CONFLICT_ERROR',
            FORBIDDEN_ERROR: 'EUROPACE_GRAPHQL_FORBIDDEN_ERROR',
            GONE_ERROR: 'EUROPACE_GRAPHQL_GONE_ERROR',
            PROCESS_NOT_FOUND_ERROR: 'EUROPACE_GRAPHQL_PROCESS_NOT_FOUND_ERROR',
            UNEXPECTED_ERROR: 'EUROPACE_GRAPHQL_UNEXPECTED_ERROR',
            UNPROCESSABLE_ERROR: 'EUROPACE_GRAPHQL_UNPROCESSABLE_ERROR',
        } as const,
        IMPORT_PROCESS: EUROPACE_IMPORT_PROCESS_ERRORS,
        READ_APPLICATIONS: {
            FORBIDDEN_ERROR: 'READ_APPLICATIONS_FORBIDDEN_ERROR',
            UNAUTHORIZED_ERROR: 'READ_APPLICATIONS_UNAUTHORIZED_ERROR',
            UNEXPECTED_ERROR: 'READ_APPLICATIONS_UNEXPECTED_ERROR',
            UNSUPPORTED_MEDIA_TYPE_ERROR: 'READ_APPLICATIONS_UNSUPPORTED_MEDIA_TYPE_ERROR',
        } as const,
        REQUEST_ACCEPTED_JOB: {
            FORBIDDEN_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_FORBIDDEN_ERROR',
            // error if the mutation request does not include the jobId in the response
            GRAPHQL_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_GRAPHQL_ERROR',
            MAX_RETRIES_EXCEEDED_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_MAX_RETRIES_ERROR',
            // error if the request is rejected by Europace
            MISSING_JOB_ID_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_MISSING_JOB_ID_ERROR',
            // error if the mutation request does not include the jonId in the response
            NOT_ACCEPTED_BY_BANK_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_NOT_ACCEPTED_BY_BANK_ERROR',
            REQUEST_FAILED_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_REQUEST_FAILED_ERROR', // error if the request returned a "Failure" status
            REQUEST_UNSUCCESSFUL_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_REQUEST_UNSUCCESSFUL_ERROR',
            UNAUTHORIZED_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_UNAUTHORIZED_ERROR',
            UNEXPECTED_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_UNEXPECTED_ERROR',
            UNSUPPORTED_MEDIA_TYPE_ERROR: 'EUROPACE_REQUEST_ACCEPTED_JOB_UNSUPPORTED_MEDIA_TYPE_ERROR', // error if the mutation request returns an empty "data" object in the response
        } as const,
        REQUEST_OFFERS: {
            CREATE_PROCESS_ERROR: 'EUROPACE_REQUEST_OFFERS_CREATE_PROCESS_ERROR',
            FORBIDDEN_ERROR: 'EUROPACE_REQUEST_OFFERS_FORBIDDEN_ERROR',
            GENERAL_UPDATE_ERROR: 'EUROPACE_REQUEST_OFFERS_GENERAL_UPDATE_ERROR',
            MAPPING_ERROR: 'EUROPACE_REQUEST_OFFERS_MAPPING_ERROR',
            PARTNERID_MISSING_ERROR: 'EUROPACE_REQUEST_OFFERS_PARTNERID_MISSING_ERROR',
            PROCESS_STILL_BEING_PROCESSED: 'EUROPACE_REQUEST_OFFERS_PROCESS_STILL_BEING_PROCESSED',
            UNAUTHORIZED_ERROR: 'EUROPACE_REQUEST_OFFERS_UNAUTHORIZED_ERROR',
            UNEXPECTED_ERROR: 'EUROPACE_REQUEST_OFFERS_UNEXPECTED_ERROR',
            UNSUPPORTED_MEDIA_TYPE_ERROR: 'EUROPACE_REQUEST_OFFERS_UNSUPPORTED_MEDIA_TYPE_ERROR',
            UPDATE_SECOND_APPLICANT_DATA_ERROR: 'EUROPACE_REQUEST_OFFERS_UPDATE_SECOND_APPLICANT_DATA_ERROR',
            REFINANCING_MISMATCH_ERROR: 'EUROPACE_REQUEST_OFFERS_REFINANCING_MISMATCH_ERROR',
            CREATION_WITH_REFINANCING_MISMATCH_ERROR:
                'EUROPACE_REQUEST_OFFERS_CREATION_WITH_REFINANCING_MISMATCH_ERROR',
        } as const,
        UPDATE_PROCESS: {
            FORBIDDEN_ERROR: 'EUROPACE_UPDATE_PROCESS_FORBIDDEN_ERROR',
            UNAUTHORIZED_ERROR: 'EUROPACE_UPDATE_PROCESS_UNAUTHORIZED_ERROR',
            UNEXPECTED_ERROR: 'EUROPACE_UPDATE_PROCESS_UNEXPECTED_ERROR',
            UNSUPPORTED_MEDIA_TYPE_ERROR: 'EUROPACE_UPDATE_PROCESS_UNSUPPORTED_MEDIA_TYPE_ERROR',
            REFINANCING_MISMATCH_ERROR: 'EUROPACE_UPDATE_PROCESS_REFINANCING_MISMATCH_ERROR',
        } as const,
        SYNC_OFFERS: {
            NOT_IMPORTED_ERROR: 'NOT_IMPORTED_ERROR',
            IMPORT_PENDING_ERROR: 'IMPORT_PENDING_ERROR',
        } as const,
    } as const,
    GENERAL: {
        UNKNOWN_ERROR: 'GENERAL_UNKNOWN_ERROR',
    } as const,
} as const;

export const SALARY_CALCULATION_OPTIONS = {
    // eslint-disable-next-line sort/object-properties
    LAST_MONTHS_SALARY: 'LAST_MONTHS_SALARY',
    LOWEST_SALARY_3_MONTHS: 'LOWEST_SALARY_3_MONTHS',
    LOWEST_SALARY_2_MONTHS: 'LOWEST_SALARY_2_MONTHS',
    AVERAGE_SALARY_3_MONTHS: 'AVERAGE_SALARY_3_MONTHS',
    AVERAGE_SALARY_2_MONTHS: 'AVERAGE_SALARY_2_MONTHS',
    MITTELWERT_MEDIAN: 'MITTELWERT_MEDIAN',
    SPECIAL_LOWEST_SALARY_DKB_SKG: 'SPECIAL_LOWEST_SALARY_DKB_SKG',
} as const;

export type SALARY_CALCULATION_OPTION = keyof typeof SALARY_CALCULATION_OPTIONS;

export const LOAN_REQUEST_TAGS = {
    DUPLICATE: 'duplicate',
    HOT_LEAD: 'hotLead',
    NEGATIVE_SCHUFA: 'negativeSchufa',
    PARTNER_NAME: 'partnerName',
    REAL_ESTATE: 'realEstate',
    STOCK: 'stock',
    SECOND_APPLICANT: 'secondApplicant',
} as const;

export type LOAN_REQUEST_TAG = ValueOf<typeof LOAN_REQUEST_TAGS>;

export const TAX_CLASSIFICATIONS = {
    CLASS_1: 'CLASS_1',
    CLASS_2: 'CLASS_2',
    CLASS_3: 'CLASS_3',
    CLASS_4: 'CLASS_4',
    CLASS_5: 'CLASS_5',
    CLASS_6: 'CLASS_6',
} as const;

export type TAX_CLASSIFICATION = ValueOf<typeof TAX_CLASSIFICATIONS>;

export const MAIL_STATUSES = { PENDING: 'PENDING', SENT: 'SENT', FAILED: 'FAILED' };

export const MAIL_FAILURE_REASONS = {
    USER_NOT_FOUND: 'USER_NOT_FOUND',
    MISSING_MAIL_META_DATA: 'MISSING_MAIL_META_DATA',
    APPLICANT_NOT_FOUND: 'APPLICANT_NOT_FOUND',
    MISSING_APPLICANT_PERSONAL_DATA: 'MISSING_APPLICANT_PERSONAL_DATA',
    MISSING_MAIL_TEMPLATE: 'MISSING_MAIL_TEMPLATE',
    MISSING_STATUS_REASON: 'MISSING_STATUS_REASON',
    LOAN_REQUEST_NOT_FOUND: 'LOAN_REQUEST_NOT_FOUND',
    LOAN_REQUEST_CONTACT_NOT_FOUND: 'LOAN_REQUEST_CONTACT_NOT_FOUND',
    STATUS_NOT_SUPPORTED: 'STATUS_NOT_SUPPORTED',
    MISSING_DIVISION_TEMPLATE: 'MISSING_DIVISION_TEMPLATE',
    LOAN_REQUEST_NOT_ASSIGNED: 'LOAN_REQUEST_NOT_ASSIGNED',
    DIVISION_ID_NOT_FOUND: 'DIVISION_ID_NOT_FOUND',
    MISSING_TEMPLATE_META_DATA: 'MISSING_TEMPLATE_META_DATA',
    MISSING_APPLICANT_CONTACT_DATA: 'MISSING_APPLICANT_CONTACT_DATA',
    UNKNOWN_ERROR: 'UNKNOWN_ERROR',
} as const;

export type MAIL_FAILURE_REASON = ValueOf<typeof MAIL_FAILURE_REASONS>;

export const CANCEL_MAIL_TEMPLATE_KINDS = {
    TEMPLATE: 'TEMPLATE',
    SKIP: 'SKIP',
    UNKNOWN: 'UNKNOWN',
} as const;

export type CANCEL_MAIL_TEMPLATE_KIND = ValueOf<typeof CANCEL_MAIL_TEMPLATE_KINDS>;

export const STATUS_MAIL_PREVIEW_KINDS = {
    PREVIEW: 'PREVIEW',
    NO_TEMPLATE: 'NO_TEMPLATE',
    NO_MAIL: 'NO_MAIL',
    NOT_SENDABLE: 'NOT_SENDABLE',
} as const;

export type STATUS_MAIL_PREVIEW_KIND = ValueOf<typeof STATUS_MAIL_PREVIEW_KINDS>;

export const SEND_MAIL_CHOICES = {
    YES: 'YES',
    NO: 'NO',
} as const;

export type SEND_MAIL_CHOICE = ValueOf<typeof SEND_MAIL_CHOICES>;

export type MAIL_STATUS = ValueOf<typeof MAIL_STATUSES>;

/** Search field keys that resolve against the Partners read model, not LoanRequests. */
export const PARTNER_SEARCH_FIELD_KEYS = {
    PARTNER_FIRST_NAME: 'partnervorname',
    PARTNER_LAST_NAME: 'partnernachname',
    PARTNER_COMPANY: 'Partnerfirma',
} as const;

export type PartnerSearchFieldKey = ValueOf<typeof PARTNER_SEARCH_FIELD_KEYS>;

export const PARTNER_SEARCH_FIELD_KEY_LIST = Object.values(
    PARTNER_SEARCH_FIELD_KEYS,
) as ReadonlyArray<PartnerSearchFieldKey>;

export const SEARCH_FIELD_PATHS = {
    antragsdatum: ['createdAt'],
    antragsnummer: ['providerApplicationNumber'],
    berater: ['firstName', 'lastName'],
    caseid: ['id'],
    email: ['antragsteller1.personendaten.email', 'antragsteller2.personendaten.email'],
    geburtsdatum: ['antragsteller1.personendaten.geburtsdatum', 'antragsteller2.personendaten.geburtsdatum'],
    geburtsort: ['antragsteller1.personendaten.geburtsort', 'antragsteller2.personendaten.geburtsort'],
    kampagne: ['utm.campaign'],
    kontonummer: ['haushalt.kontoverbindung.iban'],
    kreditsumme: ['finanzbedarf.finanzierungswunsch.kreditbetrag'],
    nachname: ['antragsteller1.personendaten.nachname', 'antragsteller2.personendaten.nachname'],
    offertoken: ['id'],
    organisation: ['organization'],
    ort: ['antragsteller1.wohnsituation.anschrift.ort', 'antragsteller2.wohnsituation.anschrift.ort'],
    plz: ['antragsteller1.wohnsituation.anschrift.plz', 'antragsteller2.wohnsituation.anschrift.plz'],
    strasse: ['antragsteller1.wohnsituation.anschrift.strasse', 'antragsteller2.wohnsituation.anschrift.strasse'],
    telefon: ['antragsteller1.personendaten.telefonPrivat', 'antragsteller2.personendaten.telefonPrivat'],
    vorname: ['antragsteller1.personendaten.vorname', 'antragsteller2.personendaten.vorname'],
    // NOTE: the next three fields are used to search for partners in the partners table and are not part of the loan request table
    [PARTNER_SEARCH_FIELD_KEYS.PARTNER_FIRST_NAME]: ['direct_partner_first_name'],
    [PARTNER_SEARCH_FIELD_KEYS.PARTNER_LAST_NAME]: ['direct_partner_last_name'],
    [PARTNER_SEARCH_FIELD_KEYS.PARTNER_COMPANY]: ['direct_partner_company_name'],
} as const;

export type SEARCH_FIELD_PATH = typeof SEARCH_FIELD_PATHS;

export const LEAD_ATTRIBUTION_STATUSES = {
    SUCCESS: 'SUCCESS',
    FAILED: 'FAILED',
    MISSING_INFORMATION: 'MISSING_INFORMATION',
} as const;

export type LEAD_ATTRIBUTION_STATUS = ValueOf<typeof LEAD_ATTRIBUTION_STATUSES>;

export const CREDIT_RATING_REJECTION_REASONS = {
    AFFILIATE_WITHOUT_SCHUFA_ACCESS: 'Affiliate adviser is not permitted to request Schufa',
    DATA_PROTECTION_NOT_AGREED: 'Applicant did not agree to the data protection',
    INVALID_APPLICANT_DATA: 'Invalid applicant data',
} as const;

export type CREDIT_RATING_REJECTION_REASON = ValueOf<typeof CREDIT_RATING_REJECTION_REASONS>;

export const AFFILIATE_LINK_KINDS = {
    AMBIGUOUS: 'ambiguous',
    NONE: 'none',
    USER: 'user',
} as const;

export const ASSIGNED_ADVISOR_LOOKUP_KINDS = {
    AMBIGUOUS: 'ambiguous',
    FOUND: 'found',
    NONE: 'none',
} as const;
